import getIn from 'immutable-less/transmute/getIn';
import PropertyFieldTypes from 'automation-ui-flow-core/fields/PropertyFieldTypes';
import PropertyValue from 'automation-ui-flow-core/fields/PropertyValue';
import CRMPropertyValueTypes from 'automation-ui-flow-core/fields/CRMPropertyValueTypes';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
import { getActionOutputsAsAddon } from 'automation-ui-action-features/data-passing/utils/actionOutputUtils';
export const createPropertyValueFromAction = action => {
  const metadata = action.getMetadata();
  const propertyName = metadata.getInputValue().getPropertyName();
  const propertyType = metadata.getInputValue().getType();
  const propertyToken = metadata.getInputValue().getPropertyToken();
  const value = metadata.getInputValue().getValue() || '';
  return new PropertyValue({
    propertyName,
    type: propertyType,
    identifier: metadata.getInputValue().getIdentifier(),
    value,
    propertyToken
  });
};
export const createPropertyValueForPropertyValueInput = (propertyAsAddon, value, action) => {
  const metadata = action.getMetadata();
  const propertyName = metadata.getInputValue().getPropertyName();
  const propertyType = metadata.getInputValue().getType();
  const propertyToken = metadata.getInputValue().getPropertyToken();
  let propertyValue = new PropertyValue({
    propertyName,
    propertyToken,
    type: propertyType,
    identifier: metadata.getInputValue().getIdentifier(),
    value
  });
  if (propertyAsAddon && propertyAsAddon.valueType === CRMPropertyValueTypes.DATETIME) {
    propertyValue = propertyValue.set('type', PropertyValueTypes.STATIC_VALUE);
  }
  return propertyValue;
};

/**
 *
 * @param {*} actionOutputs
 * @param {PropertyValue} propertyValue
 */
export const createFieldDataAddonProperty = (actionOutputs, input) => {
  const outputForSourceAction = getActionOutputsAsAddon(actionOutputs);
  const sourceActionFields = getIn([input.getTargetActionId(), 'fields'], outputForSourceAction) || [];
  return sourceActionFields.find(field => field.value === input.getDataKey());
};

/**
 * TODO ZS: this is not a perfect matching. Until
 * we support `externalOptionReferenceType` on
 * action outputs, we'll need to rely on this
 *
 * @param {*} propertyAsAddon
 */
export const createFieldDataPropertyDefinition = propertyAsAddon => {
  return {
    label: propertyAsAddon.text,
    name: propertyAsAddon.value,
    referencedObjectType: propertyAsAddon.referencedObjectType,
    // deprecated
    fieldType: propertyAsAddon.fieldType
  };
};
export const convertMultiSelectProperty = property => property.fieldType === PropertyFieldTypes.CHECKBOX ? Object.assign({}, property, {
  fieldType: PropertyFieldTypes.ENUM
}) : property;